import { useMutation } from '@tanstack/react-query';

import type { CashRegisterMutationResponse } from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useCashRegisterActionMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<CashRegisterMutationResponse>({
        method: 'PATCH',
        url,
      }),
  });
